import { useEffect, useState } from "react";
import api from "../../api"
import StreakDisplay from "./StreakDisplay"
import { motion } from "framer-motion"
import BadgeDisplay from "./BadgeDisplay";
import { getBadgesForProfile } from "../profile/Badges";

export default function ProfileSidebar() {
  const [profile, setProfile] = useState("");
  const [animatedXp, setAnimatedXp] = useState(() => {
    const saved = localStorage.getItem("previous_xp");
    return saved ? parseInt(saved) % 1250 : 0;
  });
  const [xpText, setXpText] = useState("");
 const latestBadges = getBadgesForProfile(profile).slice(-4); // last 3 badges

  // fetch profile data
  useEffect(() => {
    api.get("profile/")
      .then((res) => {
        setProfile(res.data);
      })
      .catch((err) => {
        console.error("Error loading profile:", err);
      });
    }, []);

  // refresh streak
  useEffect(() => {
    const refreshStreak = async () => {
      const token = localStorage.getItem("access");
      console.log("Refreshing streak with token:", token);
      await fetch("https://matly-backend.onrender.com/api/user/refresh_streak/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
    };
    refreshStreak();
  }, []);

  // animated progress bar
  useEffect(() => {
    if (profile?.xp !== undefined) {
      const previousXp = localStorage.getItem("previous_xp")
        ? parseInt(localStorage.getItem("previous_xp"))
        : 0;
      const target = profile.xp % 1250;
      let current = previousXp % 1250;
  
      const diff = target - current;
      const steps = 20;
      const increment = diff / steps;
      let step = 0;

      const xpGain = profile.xp - previousXp;
      if (xpGain > 0) {
        setXpText(`${previousXp} + ${xpGain} xp`);
      } else {
        setXpText(`${profile.xp} xp`);
      };
  
      const animate = () => {
        step++;
        current += increment;
        setAnimatedXp(current);
  
        if (step < steps) {
          setTimeout(animate, 30);
        } else {
          setAnimatedXp(target);
          setXpText(`${profile.xp} xp`);
          localStorage.setItem("previous_xp", profile.xp); // ✅ Save new XP
        }
      };
  
      animate();

    }
  }, [profile?.xp]);

  return(
    <div>
      <div className="profileSidebar">
        <h2>hejsa, {profile.username} 👋</h2>
        
        {/* ✅ XP Progress Bar */}
        <div className="relative w-full h-8">
          {/* Text on top of the full bar */}
          <div className="p-4 absolute inset-0 flex items-center text-sm font-major text-green-800 pointer-events-none">
            <span><strong>lVl {profile.level}</strong> · {xpText}</span>
          </div>

          {/* Background + border */}
          <div className="w-full h-full bg-green-100 rounded-2xl overflow-hidden shadow-inner border border-green-500">
            {/* Fill bar */}
            <div
              className="h-full bg-green-400 transition-all duration-500"
              style={{ width: `${animatedXp / 12.5}%` }}
            />
          </div>
        </div>

        {/* Streakinfo */}
        <StreakDisplay
          streak={profile?.streak || 0}
          isTodayActive={profile?.streak_today}
        />
          
        {/* Badges */}
        <BadgeDisplay
          latestBadges={latestBadges}
        />

      </div>
      
    </div>
  )
}